// extracted by mini-css-extract-plugin
module.exports = {"resetMobileApp":"MobileAppDevelopment_resetMobileApp__3ehhO"};